import api from './api';

export interface LaunchSquadParams {
  sessionId: string;
  preset_key: string;
  fan_width: number;
  task_brief: string;
  anchor_message_id: string;
  completion_timeout_minutes?: number;
}

export interface LaunchSquadResult {
  ok: boolean;
  squad_id: string;
  status: string;
  estimated_cost_usd?: number;
  member_count?: number;
}

export async function launchSquad(params: LaunchSquadParams): Promise<LaunchSquadResult> {
  const { sessionId, ...body } = params;
  const resp = await api.post<LaunchSquadResult>(
    `/api/sessions/${sessionId}/squads/launch`,
    body,
  );
  return resp.data;
}
